import { render, staticRenderFns } from "./AttributesEditModal.vue?vue&type=template&id=4b58dee6"
import script from "./AttributesEditModal.vue?vue&type=script&lang=ts"
export * from "./AttributesEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports